import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {getHomePageUrl} from '../../../../../../commons/selectors/environment'
import {usePageStateSelector} from '../../../hooks/state'
import s from './back-to-site-link.scss'

export const BackToSiteLink: React.FC<{className?: string}> = ({className, children}) => {
  const {t} = useTranslation()
  const url = usePageStateSelector(getHomePageUrl)

  if (!url) {
    return null
  }

  return (
    <a className={classNames(s.link, className)} data-hook={DH.BACK_TO_SITE} href={url}>
      {children ?? t('backToSite')}
    </a>
  )
}
